exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table {\n    position: relative;\n}\ntd.winner {\n    background: #666;\n    color: #FFF;\n    /* padding-left: 175px; */\n}\n.table th.fixed-left {\n    /* position: absolute;\n    height: 100%;\n    text-align: right;\n    width: 175px;\n    left: 0;\n    background: #FFF; */\n\n}\n.table thead th.winner {\n    /* padding-left: 175px; */\n}\n.table td .label {\n    display: none;\n}\n.specs-container {\n    margin-top: 30px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: distribute;\n        justify-content: space-around;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n.specs a {\n    color: #606060;\n    font-size: 30px;\n}\n@media (max-width: 767px) {\n    .table th.fixed-left {\n        display: none;\n    }\n    thead tr th:first-of-type {\n        display: none;\n    }\n    .table {\n        font-size: .7rem;\n    }\n    .table td, .table th {\n        padding: .5rem;\n        vertical-align: middle;\n    }\n    .table td .label {\n        display: block;\n    }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /tmp/build_0264da94/src/app/about/about.component.css
// module id = ../../../../../src/app/about/about.component.css
// module chunks = main